import ContactCard from '@/components/contact/card/ContactCard.vue'

export default {
  name: 'ContactList',
  data () {
    return {
      loading: true,
      managers: null
    }
  },
  components: {
    ContactCard
  },
  computed: {
    contacts () {
      if (this.managers) {
        return this.managers.filter(el => el.isContactPerson == 1);
      }
      return null;
    },
    clientName () {
      const clientPerm = this.$session.get('client_permissions');
      const selectedClient = this.$session.get('selectedClientApiId');
      if (clientPerm && clientPerm[selectedClient]) {
        return clientPerm[selectedClient].name;
      }
      return ''
    },
    clientManager () {
      const clientPerm = this.$session.get('client_permissions');
      const selectedClient = this.$session.get('selectedClientApiId');
      if (clientPerm && clientPerm[selectedClient]) {
        const managerId = clientPerm[selectedClient].manager_id;
        return this.managers.find(el => el.id === managerId);
      }
      return null;
    }
  },
  mounted () {
    const items = this.$store.getters.getItemsFromConfigWithFilter('managers');
    if (items) {
      this.managers = Object.values(items);
    }
  }
}
